module.exports = __webpack_public_path__ + "static/img/11.143cb0f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/sp/11.png
// module id = Yfgx
// module chunks = 0